import localforage from "localforage";

/**
 * 初始化本地浏览器仓库
 */
export const createLocalForage = () => {
  localforage.config({
    driver: localforage.INDEXEDDB, // 选择存储引擎，如IndexedDB
    name: "ly-data", // 数据库名称
    version: 1, // 数据库版本号
    storeName: "ly-store", // 存储对象的名称
  });
};

/**
 * 存储localforage
 */
export const setLocalForage = (name, content) => {
  if (!name) return;
  localforage
    .setItem(name, content)
    .then(() => {
      console.log("数据保存成功");
      return true;
    })
    .catch((error) => {
      console.error("数据保存失败:", error);
      return false;
    });
};

/**
 * 获取localforage
 */
export async function getLocalForage (name){
  if (!name) return;
  let res = await localforage
    .getItem(name)
    .then((value) => {
      return value;
    })
    .catch((error) => {
      return null;
    });
  return res;
};

/**
 * 删除localforage
 */
export const removeLocalForage = (name) => {
  if (!name) return;
  localforage
    .removeItem(name)
    .then(function () {
      // 当值被移除后，此处代码运行
      console.log("删除成功!");
      return true;
    })
    .catch(function (err) {
      // 当出错时，此处代码运行
      console.log("获取数据失败:", err);
      return false;
    });
};

/**
 * 获取当前时间
 * @returns 
 */
export function getNowTime(){
  function p(s) {
    return s < 10 ? '0' + s : s;
  }
  var myDate = new Date();
  //获取当前年
  var year = myDate.getFullYear();
  //获取当前月
  var month = myDate.getMonth() + 1;
  //获取当前日
  var date = myDate.getDate();
  var h = myDate.getHours(); //获取当前小时数(0-23)
  var m = myDate.getMinutes(); //获取当前分钟数(0-59)
  var s = myDate.getSeconds();

  var now = year + '-' + p(month) + "-" + p(date) + " " + p(h) + ':' + p(m) + ":" + p(s);
  return now;
};

/**
 * 判断字符串是否为当天
 * @param {*} stringDate 
 */
export const isSameDay=(stringDate)=>{
  // 将日期字符串转换为Date对象
  const d1 = new Date(stringDate);
  const d2 = new Date();
  
  // 计算两个日期相差的毫秒数
  const diffMs = Math.abs(d2 - d1);
  
  // 将毫秒数转换为天数
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  
  if(diffDays > 1)
    return false
  else
    return true
}
